import { toCurrency } from "@/shared/helpers";

export const REDEMPTION_HOLD_COLUMNS = [
    {
        Header: "User",
        accessor: "user.email",
        Cell: ({ row }) => {
            const user = row.original.user;
            if (!user) return "—";
            const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
            return name || user.email;
        },
    },
    {
        Header: "Merchant",
        accessor: "merchant.name",
        Cell: ({ value }) => value || "—",
    },
    {
        Header: "Amount",
        accessor: "redemption_value",
        Cell: ({ value }) => (value != null ? toCurrency(value) : "—"),
        width: 100,
    },
    {
        Header: "Held Since",
        accessor: "created_at",
        Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "—"),
        width: 170,
    },
    {
        Header: "Status",
        accessor: "status",
        width: 110,
    },
];
